export default "__VITE_PUBLIC_ASSET__b1adf4f3__"